<template>
  <div class="warp">
    <header-title
      :title="title"
      @onRefresh="getPickRequest2"
      has-refresh
    ></header-title>
    <div class="warp-body">
      <div class="job-card">
        <p class="special">
          <span class="flex-a">
            <span class="title">Scan:</span>
            <span class="value">
              <a-input
                type="number"
                ref="cartIdRef"
                v-model:value="cartId"
                @pressEnter="confirmCart"
              />
            </span>
          </span>
          <a-button
            type="primary"
            :disabled="!cartId"
            size="large"
            @click="confirmCart"
          >
            Confirm
          </a-button>
        </p>
        <ul class="r-list">
          <li>
            <span class="title">Job ID:</span>
            <span class="value">{{ detailInfo.workOrderId }}</span>
          </li>
          <li>
            <span class="title">Sub Job ID:</span>
            <span class="value">
              {{ detailInfo.subJobId1 }}
              <b v-if="detailInfo.subJobId1 && detailInfo.subJobId2">,</b>
              {{ detailInfo.subJobId2 }}
            </span>
          </li>
          <li>
            <span class="title">Target Line:</span>
            <span class="value">{{ detailInfo.targetLine }}</span>
          </li>
          <li>
            <span class="title">Target Area:</span>
            <span class="value">{{ detailInfo.targetId }}</span>
          </li>
        </ul>
      </div>

      <div class="table-box" id="aTableRef">
        <a-table
          :columns="columns"
          :row-key="(record) => record.id"
          :data-source="tableData"
          :loading="tableLoading"
          :pagination="{ defaultPageSize: 20 }"
          :scroll="{ x: isMobile ? 1200 : 'auto', y: tableYHeight }"
          size="small"
        ></a-table>
      </div>
    </div>
  </div>
</template>

<script>
  import HeaderTitle from '@/layout/header-title'

  import { mapGetters } from 'vuex'
  import { throttle } from '@/utils'
  import {
    showPickDetailList,
    showPickConfirm,
  } from '@/api/supermarket'
  import { Modal } from 'ant-design-vue'
  export default {
    components: {
      HeaderTitle,
    },

    data() {
      return {
        title: 'Task Details',
        cartId: '',
        num: 0,
        detailInfo: {},
        tableLoading: false,
        tableYHeight: 300,
        tableData: [],
        columns: [
          {
            title: 'No',
            dataIndex: 'no',
            key: 'no',
            customRender({ index }) {
              return index + 1
            },
            width: '8%',
          },
          {
            title: 'Part Number',
            dataIndex: 'partNo',
            width: '14%',
          },
          {
            title: 'Part Name',
            dataIndex: 'partName',
            width: '43%',
          },
          {
            title: 'Bin Location',
            dataIndex: 'location',
            width: '20%',
          },
          {
            title: 'ReqQty',
            dataIndex: 'qty',
            width: '20%',
          },
        ],
      }
    },
    created() {
      this.getPickRequest2()
    },

    computed: {
      isMobile() {
        return this.device === 'mobile'
      },
      isTJBranch() {
        return this.currentSystem * 1 === 1
      },
      ...mapGetters({
        device: 'settings/device',
        currentSystem: 'user/currentSystem',
      }),
    },
    mounted() {
      setTimeout(this.setTableScrollH, 2000)
      window.addEventListener('resize', throttle(this.setTableScrollH, 100))
      this.$refs.cartIdRef.focus()
    },
    methods: {
      setTableScrollH() {
        let top = 150
        const obj = document.getElementById('aTableRef')

        if (obj) {
          top = Math.max(obj.getBoundingClientRect().top, 150)
        }
        const wH = window.innerHeight
        const wW = window.innerWidth
        this.tableYHeight = wH - (top + 120 * (wW / 1600))
      },
      async getPickRequest2() {
        this.tableLoading = true
        const _this = this
        try {
          const d = await showPickDetailList({
            pickId: this.$route.params.pickId,
          })
          if (d.errCode === '0000') {
            this.detailInfo = d.body
            this.tableData = d.body.items
          } else {
            Modal.error({
              title: 'Error',
              content: d.errMsg,
              onOk() {
                _this.$router.go(-1)
              },
            })
          }

          this.tableLoading = false
        } catch (e) {
          this.tableLoading = false
        }
      },
      async confirmCart(val) {
        let _this = this
        let _cartId = this.cartId || val
        if (!_cartId) return false
        if (this.num === 0) {
          showPickConfirm({
            pickId: this.$route.params.pickId,
            cartId: _cartId,
          })
            .then(async () => {
              this.num++
              this.$router.go(-1)
              _this.cartId = ''
            })
            .catch(() => {
              _this.cartId = ''
              _this.$refs.cartIdRef.focus()
            })
        }
      }
    },
  }
</script>

<style lang="less" scoped>
  @import './supermarket.less';

  .table-box {
    padding: 0;
  }
  @media screen and (max-width: 720px) {
    .warp-body {
      height: calc(100vh - 34px - 44px - 10px);
    }
  }
</style>
